import { Component } from '@angular/core';
import { Observable } from 'rxjs';

import { Environment } from '../../../models/environment.type';
import { CompatibilityService } from '../../../services/compatibility.service';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';
import { CompatibilityCardComponent } from '../../shared/compatibility-card/compatibility-card.component';

@Component({
    selector: 'app-environment-selection',
    templateUrl: './environment-selection.component.html',
    styleUrls: ['./environment-selection.component.scss'],
    standalone: true,
    imports: [
        CompatibilityCardComponent,
        AsyncPipe,
        TranslateModule,
    ],
})
export class EnvironmentSelectionComponent {
  selectedEnvironment$: Observable<Environment | null> =
    this.compatibilityService.selectedEnvironment$;

  constructor(private compatibilityService: CompatibilityService) {}

  onSelectEnvironment(choice: Environment): void {
    this.compatibilityService.selectEnvironment(choice);
  }
}
